<template>
  <div class="relative h-full w-full">

    <Transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="basket && basket.items.length > 0"
        class="relative flex h-full w-full transform flex-col items-start overflow-y-auto bg-[#FDFDFD] pt-8"
      >

          <button class="outline-none absolute left-auto right-4 top-4 text-center text-sm text-black z-10" @click="emit('close')" type="button">
              <img src="~/assets/icon/icon-close-gray-black.svg" alt="" class="h-8 rounded-full bg-black opacity-20">
          </button>

        <strong class="px-4 text-2xl font-medium">
          {{ basket?.total_items || 0 }} {{ pluralizedItemsInCartCountWord }} на
          <AnimatedNumber :number="basket?.total_price || 0" /> &#8381;
        </strong>

        <!--<p class="mt-2 px-4 opacity-50">{{ displayDeliveryCost }}</p>-->
        <div class="relative my-4 flex w-full grow flex-col items-stretch py-4">
          <ul class="px-4">
              <template v-for="position in basket?.items"
                        :key="position.id">
            <li
              v-if="position.in_stock > 0"
              class="my-2 flex w-full gap-2 rounded-xl bg-white p-4 shadow-main"
            >

              <template v-if="!position.price">
                <img
                  class="h-full w-24 self-center object-contain object-center lg:h-24 lg:w-36"
                  :src="position.img"
                  alt=""
                />
                <div class="flex grow flex-col items-stretch justify-between self-stretch">
                  <div class="flex items-start justify-between">
                    <div>
                      <p class="text-black">{{ position.name }}</p>
                      <p class="text-sm text-black opacity-50">{{ position.weight }} гр</p>
                    </div>
                  </div>
                  <div class="flex items-end justify-end">
                    <span class="font-medium text-orange-200">Подарок к заказу</span>
                  </div>
                </div>
              </template>

              <template v-else>
                <img
                  class="h-full w-24 self-center object-contain object-center lg:h-24 lg:w-36"
                  :src="position.img"
                  alt=""
                />
                <div class="flex grow flex-col items-stretch justify-between self-stretch">
                  <div class="flex items-start justify-between">
                    <div>
                      <p class="text-black">{{ position.name }}</p>
                      <p class="text-sm text-black opacity-50">{{ position.weight }} гр</p>
                    </div>
                    <button
                      type="button"
                      title="Удалить блюдо из корзины"
                      @click="removeAll(position)"
                    >
                      <IconClose class="h-6" />
                    </button>
                  </div>
                  <div class="flex items-end justify-between">
                      <div class="flex flex-col sm:flex-row sm:gap-3">
                          <p class="mt-auto text-lg text-black">{{ position.price }}&nbsp;&#8381;</p>
                          <p v-if="position.discount > 0" class="mt-auto text-lg text-black">Скидка: {{ position.discount }}&nbsp;&#8381;</p>
                      </div>

                    <div>
                      <DishAdder
                        class="h-8 w-28 md:w-32"
                        hide-button
                        :dish-id="position.dish_id"
                        :dish-name="position.name"
                        :can-deliver="true"
                        :available="1"
                      />
                    </div>
                  </div>
                </div>
              </template>

            </li>

              </template>
          </ul>
        </div>

          <template v-if="hasNotAvailableItems">
              <h3 class="px-4 text-1xl font-medium"><img src="data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M5.31171%2010.7615C8.23007%205.58716%209.68925%203%2012%203C14.3107%203%2015.7699%205.58716%2018.6883%2010.7615L19.0519%2011.4063C21.4771%2015.7061%2022.6897%2017.856%2021.5937%2019.428C20.4978%2021%2017.7864%2021%2012.3637%2021H11.6363C6.21356%2021%203.50217%2021%202.40626%2019.428C1.31034%2017.856%202.52291%2015.7061%204.94805%2011.4063L5.31171%2010.7615ZM12%207.25C12.4142%207.25%2012.75%207.58579%2012.75%208V13C12.75%2013.4142%2012.4142%2013.75%2012%2013.75C11.5858%2013.75%2011.25%2013.4142%2011.25%2013V8C11.25%207.58579%2011.5858%207.25%2012%207.25ZM12%2017C12.5523%2017%2013%2016.5523%2013%2016C13%2015.4477%2012.5523%2015%2012%2015C11.4477%2015%2011%2015.4477%2011%2016C11%2016.5523%2011.4477%2017%2012%2017Z'%20fill='%23EB001B'/%3e%3c/svg%3e" class="inline"> Блюда, которые недоступны в выбранном ресторане:</h3>
              <div class="relative my-4 flex w-full grow flex-col items-stretch py-4">
                  <ul class="px-4">
                      <template v-for="position in basket?.items"
                      :key="position.id">
                          <li
                              v-if="position.in_stock < 1"
                              class="my-2 flex w-full gap-2 rounded-xl bg-white p-4 shadow-main"
                          >
                                  <img
                                      class="h-full w-24 self-center object-contain object-center lg:h-24 lg:w-36"
                                      :src="position.img"
                                      alt=""
                                  />
                                  <div class="flex grow flex-col items-stretch justify-between self-stretch">
                                      <div class="flex items-start justify-between">
                                          <div>
                                              <p class="text-black">{{ position.name }}</p>
                                              <p class="text-sm text-black opacity-50">{{ position.weight }} гр</p>
                                          </div>
                                          <button
                                              type="button"
                                              @click="removeAll(position)"
                                          >
                                              <IconClose class="h-6" />
                                          </button>
                                      </div>
                                      <div class="flex items-end justify-between">
                                          <p class="mt-auto text-lg text-black">{{ position.price }} &#8381;</p>
                                          <p v-if="position.discount > 0" class="mt-auto text-lg text-black">Скидка: {{ position.discount }} &#8381;</p>
                                          <div>
                                              <DishAdder
                                                  class="h-8 w-28 md:w-32"
                                                  hide-button
                                                  :dish-id="position.dish_id"
                                                  :dish-name="position.name"
                                                  :can-deliver="true"
                                                  :available="1"
                                              />
                                          </div>
                                      </div>
                                  </div>
                          </li>
                      </template>

                  </ul>
              </div>
          </template>

          <div class="p-4 my-4" v-if="basket.recommendations.length > 0">
              <h2 class="mb-5 flex items-center gap-2 text-xl font-normal">С этим часто берут</h2>
              <div class="flex overflow-x-auto grid-cols-3 gap-4 scrollbar-track-black/5 scrollbar-thumb-black/10 hover:scrollbar-thumb-black/15 md:grid">

                  <template
                      v-for="recommendedDish in basket.recommendations"
                      :key="recommendedDish.id"
                  >
                      <div class="min-w-[40%] flex">
                          <DishCard
                              :dish="recommendedDish"
                              :big_card="false"
                              :show-weight="false"
                              :size="'small'"
                          />
                      </div>

                  </template>
              </div>
          </div>

          <div class="px-4 w-full" v-if="basket.additional_dishes.length > 0">
              <h2 class="mt-5 flex items-center gap-2 text-xl font-normal">Добавить к заказу?</h2>
              <div>

                  <div class="relative mb-4 flex w-full grow flex-col items-stretch pb-4">
                      <div class="-ms-1 lg:-ms-2">

                      <ClientOnly>
                          <swiper-container ref="containerRef" :observer="true" :observe-parents="true" :slides-per-view="2.5">
                              <swiper-slide
                                  v-for="recommendedDish in basket.additional_dishes"
                                  :key="recommendedDish.id"
                              >
                                  <div class="px-1 lg:px-2 py-4">
                                      <DishCardSmall
                                          :dish="recommendedDish"
                                          :big_card="false"
                                          :size="'small'"
                                          :show-weight="false"
                                      />
                                  </div>
                              </swiper-slide>
                          </swiper-container>
                      </ClientOnly>
                      </div>
                  </div>

              </div>
          </div>


        <div class="my-8 w-full px-4" id="guestCountWrapper">
          <div class="flex w-full items-center justify-between rounded-lg p-4 shadow-elevated">
            <span>Укажите количество персон</span>
            <div class="h-8 w-28 md:w-32">
              <InputNumberAdder
                name="guests_count"
                :min="1"
                :max="99"
              />
            </div>
          </div>
            <div v-if="showGuestCountError" class="text-red mt-3 text-lg flex gap-2">
               <DangerTriangle></DangerTriangle> Пожалуйста, укажите количество персон
            </div>
        </div>

        <div class="w-full px-4 pt-4">

            <!--
          <label class="mb-8 flex items-center justify-between gap-4">
            <div>
              <div>Вкусоины</div>
              <div class="text-sm font-normal text-black/50">
                <template v-if="basket.gifts.coins_can_use > 0">
                 Можно списать: {{basket.gifts.coins_can_use}}
                </template>
                <template v-else>
                 Нет бонусов для списания
                </template>
              </div>
            </div>
            <InputSwitch name="use_coins" :disabled="basket.gifts.coins_can_use < 1" />
          </label>-->

            <div class="mb-8 mt-8" v-if="loyaltyPrograms && loyaltyPrograms.length > 0">
                <div>
                    <h2 class="mt-5 flex items-center gap-2 text-xl">Выберите акцию</h2>

                    <HeadlessRadioGroup v-model="selectedLoyaltyProgram"
                                        :by="comparePrograms"
                                        class="flex gap-3 flex-col mt-2">
                        <HeadlessRadioGroupOption v-for="program in loyaltyPrograms"
                                                  v-slot="{ active, checked }"
                                                  :value="program"
                                                  :key="program.id"
                        >

                            <div
                                class="rounded-[7px] lg:rounded-[20px] border  p-2.5 lg:p-7 flex flex-col gap-2.5 items-center self-stretch shadow-main relative w-full bg-white cursor-pointer" :class="{
                                'border-[0.1rem] border-orange-200': checked,
                                'border-[#f9f9f9]': !checked,
                                }" >

                                <div class="flex gap-2.5 lg:gap-4 items-center self-stretch relative w-full text-3xl">

                                <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle
                                        cx="10.5"
                                        cy="10.5"
                                        r="5.15"
                                        stroke="#B2B0AE"
                                        stroke-width="0.7" />
                                    <circle v-if="checked"
                                        cx="10.4992"
                                        cy="10.5002"
                                        r="3.3"
                                        fill="#F38E3B" />
                                </svg>
                                <div
                                    class="flex flex-col lg:flex-row gap-1 justify-center lg:justify-between items-start lg:items-center flex-1 relative w-full">
                                    <span class="text-xs lg:text-lg leading-[14px] text-[#252321] font-medium">
                                        {{ program.name }}
                                    </span>

                                    <span class="text-[10px] lg:text-[14px] leading-3 text-[#767472]">
           <span v-if="program.bonuses_award_sum > 0">
                                  Начислим {{program?.bonuses_award_sum}} {{$HelperWordsDeclension(program?.bonuses_award_sum, ['балл', 'балла', 'баллов'])}}
                              </span>
                                    <span v-if="program.bonuses_available_to_spend > 0">
                                  Спишем {{program?.bonuses_available_to_spend}} {{$HelperWordsDeclension(program?.bonuses_available_to_spend, ['балл', 'балла', 'баллов'])}}
                              </span>
                                    <span v-if="program.total_discount > 0">
                                  Скидка: {{program.total_discount}} руб.
                              </span>
                                    <span v-if="program.free_products.length > 0 && checked">
                                  Подарок уже в корзине
                              </span>
                                    </span>
                                </div>

                                </div>
                                <div v-if="(program.id == 'coupon' || checkedCouponProgram?.id == program.id) && checked" class="w-full">
                                    <OrderDialogInputPromocode
                                        name="coupon"
                                        class="mb-4"
                                        placeholder="Введите промокод"
                                    />
                                    <div v-if="checkedCouponProgram">
                                        {{checkedCouponProgram.name}}
                                    </div>
                                    <div v-if="isFetching && coupon?.length > 0"
                                         class="ms-2 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                                         role="status">
                                        <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
                                    </div>
                                    <div v-if="coupon?.length > 0 && !couponFound && !isFetching" class="text-red">
                                        Промокод не найден
                                    </div>
                                </div>
                            </div>

                        </HeadlessRadioGroupOption>
                    </HeadlessRadioGroup>
                </div>
            </div>

        </div>
          <div class="bg-white w-full px-4 pt-4 pb-8 border-t-[1px] border-solid border-[#F9F9F9]">
              <div
                  v-if="basket.total_discount"
                  class="flex items-center justify-between"
              >
                  <span>Скидка</span>
                  <span><AnimatedNumber :number="basket.total_discount" /> &#8381;</span>
              </div>

              <div class="flex items-center justify-between">
                  <span>{{ basket?.total_items }} {{ pluralizedItemsInCartCountWord }}</span>
                  <span><span v-if="basket.total_discount > 0" class="line-through opacity-30 pr-2">{{basket?.total_price || 0}}</span><AnimatedNumber :number="(basket?.total_price - basket?.total_discount) || 0" /> &#8381;</span>
              </div>

              <div class="flex items-center justify-between" v-if="basket.paid_with_bonuses > 0">
                  <span>Будет оплачено баллами</span>
                  <span><AnimatedNumber :number="basket.paid_with_bonuses" /> &#8381;</span>
              </div>

              <div class="flex items-center justify-between">
                  <span>Доставка <span v-if="basket.spend_for_free_delivery > 0">({{basket.spend_for_free_delivery}} руб. до бесплатной доставки)</span>
                        <span class="shrink-0 ms-2" v-if="user?.delivery_zone.info_text.length > 0">
                        <Tooltip>
                            {{user?.delivery_zone.info_text}}
                        </Tooltip>
                      </span>
                  </span>
                  <span class="shrink-0"><AnimatedNumber :number="basket.delivery_price" /> &#8381;</span>
              </div>
              <div v-if="showGuestCountError" class="text-red mt-3 flex gap-2">
                  <DangerTriangle></DangerTriangle> Пожалуйста, укажите количество персон в поле выше
              </div>
              <div class="flex mt-6 sm:mt-10 gap-3 sm:gap-5 justify-between items-end flex-col sm:flex-row">
                  <ShareCartButton></ShareCartButton>

                  <div class="w-full">
                      <SimpleButton
                          :disabled="basket?.total_items == 0"
                          class="w-full px-4 py-4 text-xs uppercase"
                          type="button"
                          @click="proceedToPayment"
                      >
                          Перейти к оформлению <IconArrowRight class="inline h-4" />
                      </SimpleButton>
                  </div>
              </div>
          </div>
      </div>

      <div
        v-else
        class="flex h-full items-center justify-center"
      >
          <button class="outline-none absolute left-auto right-4 top-4 text-center text-sm text-black z-10" @click="emit('close')" type="button">
              <img src="~/assets/icon/icon-close-gray-black.svg" alt="" class="h-8 rounded-full bg-black opacity-20">
          </button>
        <div
          class="relative flex max-w-xs flex-col items-center rounded-xl bg-blue-100 px-1 pb-20 pt-12 text-center lg:max-w-sm lg:pb-24"
        >
          <img
            class="h-12 lg:h-14"
            src="/fish.svg"
            alt=""
          />
          <strong class="mt-2 text-base font-bold uppercase lg:text-xl"> ой, кажется, Корзина пуста </strong>
          <p class="mt-4 text-sm">Ваша корзина пуста, откройте «Меню» и выберите понравившийся товар</p>
          <p class="mt-2 text-sm">Мы бесплатно доставим ваш заказ от {{ main?.from_deliver }} ₽</p>

          <img
            src="/upset-cup.svg"
            class="absolute top-0 h-24 -translate-y-3/4 transition-opacity lg:h-32"
            :class="isCupReady ? 'opacity-100' : 'opacity-0'"
            alt=""
          />

          <img
            src="/upset-sushi.svg"
            class="absolute bottom-0 h-32 max-w-none translate-y-1/2 transition-opacity lg:h-40"
            :class="isSushiReady ? 'opacity-100' : 'opacity-0'"
            alt=""
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useImage } from '@vueuse/core'
import AnimatedNumber from '~/components/AnimatedNumber.vue'
import type { DishInBasket } from '~/interfaces/main'
import { type LoyaltyProgram, useLoyaltyPrograms } from '~/composables/api/basket'
import { useToast } from 'vue-toastification'
import MyToastError from '~/components/MyToastError.vue'
import { useCartDialogStore } from '~/store/cartDialog'
import { storeToRefs } from 'pinia'
import DangerTriangle from '~/components/icon/DangerTriangle.vue'

const emit = defineEmits(['proccedToPayment', 'cartItemsUpdated', 'close'])

const {value: coupon} = useField<string>('coupon')
const {value: spendValue} = useField<string>('spend')
const {value: guestsCount} = useField<string>('guests_count')
const showGuestCountError = ref(false)

const cartDialogStore = useCartDialogStore()
const { selectedLoyaltyProgram } = storeToRefs(cartDialogStore)

const hasNotAvailableItems = ref(false)
const couponFound = ref<boolean | undefined>(undefined)
const { $HelperWordsDeclension } = useNuxtApp();

const { value: loyaltyProgramId } = useField<string>('loyalty_program_id')

watch(guestsCount, (w) => {
    showGuestCountError.value = !(w > 0)
})

watch(selectedLoyaltyProgram, () => {
    if (selectedLoyaltyProgram.value?.id) {
        loyaltyProgramId.value = selectedLoyaltyProgram.value?.id

        if (selectedLoyaltyProgram.value?.bonuses_available_to_spend == 0) {
            spendValue.value = ""
        }
    }
})

const toast = useToast()
//const enabled = computed(() => !!selectedLoyaltyProgram.value?.id);
const enabled = computed(() => true);

const proceedToPayment = () => {
    showGuestCountError.value = false
    if (guestsCount.value == 0) {
        showGuestCountError.value = true
        const target = document.getElementById("guestCountWrapper");
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth" });
        return;
    }
    if (selectedLoyaltyProgram.value?.id == 'coupon' && checkedCouponProgram.value == undefined) {
        toast({
                component: MyToastError,
                props: {
                    title: 'Ошибка',
                    detail: 'Укажите промокод и нажмите кнопку "Применить".\nИли выберите другую акцию',
                }
            },
            {
                timeout: 6000
            })
        return
    }
    emit('proccedToPayment')
}

const { data: user } = useUser((v) => v)
const { data: basket } = useBasketWithGifts((v) => {
    emit('cartItemsUpdated', v)

    hasNotAvailableItems.value = v.items.some((el) => el.in_stock < 1);
    return v
}, { enabled, coupon, loyalty_program_id: loyaltyProgramId })

const checkedCouponProgram = ref<LoyaltyProgram>()
const comparePrograms = (a?: LoyaltyProgram, b?: LoyaltyProgram) => {
    return a?.id === b?.id
}
const { data: loyaltyPrograms, isPending, isFetching } = useLoyaltyPrograms((v) => {
    checkedCouponProgram.value = undefined
    let programs: LoyaltyProgram[] = [],
        couponProgram: LoyaltyProgram = {
            id: "coupon",
            name: "Промокод",
            bonuses_award_sum: 0,
            coupon: "",
            bonuses_available_to_spend: 0,
            discount: [],
            free_products: [],
            total_discount: 0,
        }
    if (v.length > 0) {
        let loyaltyProgramFound = !selectedLoyaltyProgram.value || selectedLoyaltyProgram.value.id == 'coupon'
        v.forEach((program) => {
            if(program.coupon.length > 0) {
                checkedCouponProgram.value = program
                couponProgram.discount = program.discount
                couponProgram.free_products = program.free_products
                couponProgram.total_discount = program.total_discount
                selectedLoyaltyProgram.value = couponProgram
                loyaltyProgramFound = true

                return
            }

            if(selectedLoyaltyProgram.value?.id == program.id) {
                loyaltyProgramFound = true
            }

            programs.push(program)
        })

        let loyaltyProgram = v[0]
        if (coupon?.value && coupon.value.length > 0) {
            couponFound.value = false
            v.forEach((item) => {
                if(item.coupon.length > 0) {
                    loyaltyProgram = item
                    couponFound.value = true
                }
            });
        }

        if(selectedLoyaltyProgram.value && !loyaltyProgramFound) {
            toast({
                    component: MyToastError,
                    props: {
                        title: 'Акция недоступна',
                        detail: 'Выбранная акция "'+selectedLoyaltyProgram.value.name+'" недоступна.\nВыберите другую акцию из списка',
                    }
                },
                {
                    timeout: 6000
                })
            selectedLoyaltyProgram.value = programs[0]
        }

        ///let selectProgram = {id: "", name: "Выберите акцию", bonuses_award_sum: 0},
        //    programs = [selectProgram]
        //programs = [...programs, ...v]
        if (!selectedLoyaltyProgram.value) {
            selectedLoyaltyProgram.value = programs[0]
        }
    }

    programs.push(couponProgram)

    return programs
}, { enabled: true, coupon })

const { data: main } = useMain((v) => v)

const pluralizedItemsInCartCountWord = computed(() => {
  if (basket.value?.total_items === 1) return 'товар'
  if (basket.value?.total_items === 2) return 'товара'
  if (basket.value?.total_items === 3) return 'товара'
  if (basket.value?.total_items === 4) return 'товара'
  return 'товаров'
})
/*
const displayDeliveryCost = computed(() => {
  if (main.value && basket.value) {
    if (basket.value.total_sum > main.value.from_deliver) {
      return 'Бесплатная доставка'
    } else {
      return `Стоимость доставки ${main.value.deliver_price} ₽`
    }
  }
  return 'Нет данных'
})*/

const { mutate } = useAddToBasket()

const removeAll = (position: DishInBasket) => {
  mutate({
    id: position.id,
    quantity: 0,
    dish_id: position.dish_id,
    dish_name: position.name,
  })
}

const { isReady: isCupReady } = useImage({ src: '/upset-cup.svg' })
const { isReady: isSushiReady } = useImage({ src: '/upset-sushi.svg' })
</script>
